module.exports = __webpack_public_path__ + "static/media/loader.eb329466.gif";